import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { truncateIfTooLong } from 'src/util/truncate';

export type MatchScorerProps = {
  team1Name?: string;
  team2Name?: string;
  hasScore: boolean;
  handleSwtichChange: any;
  team1Ref: React.RefObject<HTMLInputElement>;
  team2Ref: React.RefObject<HTMLInputElement>;
};

export const MatchScorer: React.FC<MatchScorerProps> = ({
  team1Name,
  team2Name,
  hasScore,
  handleSwtichChange,
  team1Ref,
  team2Ref,
}) => {
  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={<Switch checked={hasScore} onChange={handleSwtichChange} />}
          label="Show Score?"
          sx={{ m: 0 }}
        />
      </FormGroup>

      {hasScore && (
        <Stack direction="row" spacing={2}>
          {team1Name && (
            <TextField
              type="number"
              inputRef={team1Ref}
              label={`${truncateIfTooLong(team1Name)} Score`}
              defaultValue={0}
              sx={{ maxWidth: '140px' }}
              InputLabelProps={{ shrink: true }}
            />
          )}
          {team2Name && (
            <TextField
              type="number"
              inputRef={team2Ref}
              label={`${truncateIfTooLong(team2Name)} Score`}
              defaultValue={0}
              sx={{ maxWidth: '140px' }}
              InputLabelProps={{ shrink: true }}
            />
          )}
        </Stack>
      )}
    </>
  );
};
